/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from "recharts";
import { getInvoices, getSentInvoices, IrpgetInvoices } from "../api";
import InvoiceCreateModal from "../components/InvoiceCreateModal";
import CampaignManager from "../components/CampaignManager"; // New component

// Import integration APIs
import IntegrationTab from '../components/IntegrationTab';
import { 
  getIntegrationStatus, 
  testConnection, 
  configureIntegration, 
  syncFromExternal,
  getUnmappedRecords,
  autoMapRecords,
  getAvailableProviders
} from "../utils/api/integrations";

export default function Finance() {
  // Tab state
  const [activeTab, setActiveTab] = useState('overview');
  
  // Tab content components
  const tabs = [
    { id: 'overview', label: 'Overview', icon: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg> },
    { id: 'invoices', label: 'Invoices', icon: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> },
    { id: 'campaigns', label: 'Campaigns', icon: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg> },
    { id: 'integration', label: 'MCP Integration', icon: <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'currentColor' }}></div> }
  ];

  // Render active tab content
  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewTab />;
      case 'invoices':
        return <InvoicesTab />;
      case 'campaigns':
        return <CampaignsTab />;
      case 'integration':
        return <IntegrationTab />;
      default:
        return <InvoicesTab />;
    }
  };

  return (
    <div className="finance-container">
      {/* Tab Navigation */}
      <div className="tabs-container" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #E5E7EB', marginBottom: '20px', paddingBottom: '0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
          {tabs.map(tab => (
            <div
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={
                activeTab === tab.id
                ? { 
                    display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 16px', borderRadius: '999px', 
                    fontSize: '13px', fontWeight: '600', cursor: 'pointer', marginBottom: '8px', 
                    backgroundColor: '#8B5CF6', 
                    color: '#fff' 
                  }
                : { 
                    display: 'flex', alignItems: 'center', gap: '6px', color: '#9CA3AF', fontSize: '14px', 
                    fontWeight: '500', paddingBottom: '12px', borderBottom: '2px solid transparent', cursor: 'pointer' 
                  }
              }
            >
              {tab.icon}
              {tab.label}
            </div>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      {renderTabContent()}
    </div>
  );
}

// Invoices Tab Component
function InvoicesTab() {
  const [invoices, setInvoices] = useState([]);
  const [invoicesLoader, setInvoicesLoader] = useState(false);
  const [showInvoiceCreateModal, setShowInvoiceCreateModal] = useState(false);

  useEffect(() => {
    loadInvoices();
  }, []);

  const loadInvoices = async () => {
    try {
      setInvoicesLoader(true);
      const data = await getSentInvoices();
      const mockData = [
        { invoiceNo: 'INV-1024', Customer: 'Tech Innovators Inc.', Amount: '12,500.00', Due: '2026-06-25', status: 'Pending', Risk: 'Low' },
        { invoiceNo: 'INV-1025', Customer: 'Global Synergy Corp', Amount: '8,250.00', Due: '2026-06-18', status: 'Overdue', Risk: 'High' },
        { invoiceNo: 'INV-1026', Customer: 'Dynamic Solutions', Amount: '4,100.00', Due: '2026-07-02', status: 'Paid', Risk: 'Low' }
      ];
      setInvoices(data?.data?.length ? data.data : mockData);
    } catch (error) {
      console.error("Error loading invoices:", error);
    } finally {
      setInvoicesLoader(false);
    }
  };

  const createInvoice = async (invoiceData) => {
    return new Promise((resolve) => {
      console.log('Creating invoice:', invoiceData);
      setInvoices(prev => [invoiceData, ...prev]);
      resolve();
    });
  };

  return (
    <>
      <div className="row-split">
        <div className="full-width card" style={{width:"100%"}}>
          <div className="card-title" style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center' 
          }}>
            <span>Invoices</span>
            <button 
              onClick={() => setShowInvoiceCreateModal(true)}
              style={{
                padding: '8px 16px',
                background: '#4caf50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '14px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 6
              }}
            >
              <span>+</span>
              <span>Create Invoice</span>
            </button>
          </div>
          
          <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Customer</th>
                <th>Amount</th>
                <th>Due</th>
                <th>Status</th>
                <th>Risk</th>
              </tr>
            </thead>
            <tbody>
              {invoicesLoader ? (
                <tr><td colSpan="6"><div>Loading invoices...</div></td></tr>
              ) : invoices?.length > 0 ? (
                invoices.map((val, index) => (
                  <tr key={index}>
                    <td>
                      <div>{val?.invoiceNumber || val?.invoiceNo || `INV-${index}`}</div>
                    </td>
                    <td>{val?.leadName || val?.Customer || 'N/A'}</td>
                    <td>₹{val?.amount !== undefined ? val.amount : val?.Amount}</td>
                    <td>{val?.dueDate ? new Date(val.dueDate).toLocaleDateString('en-GB') : (val?.Due || '-')}</td>
                    <td><span className="status-pill status-warn">{val?.status}</span></td>
                    <td><span className="status-pill status-risk">{val?.Risk || 'Low'}</span></td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="6">No Invoices</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <InvoiceCreateModal
        isOpen={showInvoiceCreateModal}
        onClose={() => setShowInvoiceCreateModal(false)}
        onCreate={createInvoice}
      />
    </>
  );
}

// Campaigns Tab Component
function CampaignsTab() {
  return <CampaignManager />;
}



// Overview Tab Component
function OverviewTab() {
  const cashFlowData = [
    { name: 'Apr 6', inflow: 105, outflow: -80 },
    { name: 'Apr 13', inflow: 140, outflow: -90 },
    { name: 'Apr 20', inflow: 120, outflow: -100 },
    { name: 'Apr 27', inflow: 150, outflow: -70 },
    { name: 'May 4',  inflow: 80, outflow: -40 },
    { name: 'May 11', inflow: 110, outflow: -120 },
    { name: 'May 18', inflow: 130, outflow: -90 },
    { name: 'May 25', inflow: 160, outflow: -110 },
  ];

  const revenueData = [
    { name: 'Apr 6', value: 100 },
    { name: 'Apr 13', value: 150 },
    { name: 'Apr 20', value: 130 },
    { name: 'Apr 27', value: 180 },
    { name: 'May 4', value: 200 },
    { name: 'May 11', value: 170 },
    { name: 'May 18', value: 220 },
    { name: 'May 25', value: 250 },
  ];

  const expenseData = [
    { name: 'Software & Tools', value: 86750, color: '#6366f1' },
    { name: 'Salaries & Benefits', value: 124240, color: '#8b5cf6' },
    { name: 'Marketing', value: 45780, color: '#38bdf8' },
    { name: 'Operations', value: 33450, color: '#2dd4bf' },
    { name: 'Other', value: 22340, color: '#e2e8f0' },
  ];

  const transactions = [
    { date: 'May 27, 2026', description: 'Invoice #INV-0042', type: 'Invoice', amount: '$12,500.00' },
    { date: 'May 26, 2026', description: 'AWS Services', type: 'Expense', amount: '-$2,245.80' },
    { date: 'May 26, 2026', description: 'Payment from Acme Corp', type: 'Payment', amount: '$24,500.00' },
    { date: 'May 25, 2026', description: 'Office Supplies', type: 'Expense', amount: '-$842.40' },
    { date: 'May 24, 2026', description: 'Invoice #INV-0041', type: 'Invoice', amount: '$8,750.00' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0', color: '#111827' }}>Finance</h2>
        <div style={{ display: 'flex', gap: '12px' }}>
          <select style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #E5E7EB', backgroundColor: '#fff', fontSize: '14px', color: '#374151', cursor: 'pointer' }}>
            <option>All Accounts</option>
          </select>
          <button style={{ padding: '8px 16px', backgroundColor: '#6366f1', color: '#fff', borderRadius: '8px', border: 'none', fontWeight: '500', fontSize: '14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>+</span> New Invoice
          </button>
        </div>
      </div>

      {/* Metrics Row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }}>
        <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <div style={{ fontSize: '14px', color: '#6B7280', marginBottom: '8px', fontWeight: '500' }}>Cash Balance</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>$1,256,890</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div style={{ fontSize: '13px', color: '#10B981', fontWeight: '500' }}>+8.2% vs last month</div>
            <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: '#D1FAE5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10B981' }}>
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line></svg>
            </div>
          </div>
        </div>

        <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <div style={{ fontSize: '14px', color: '#6B7280', marginBottom: '8px', fontWeight: '500' }}>Invoices Due</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>$178,340</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div style={{ fontSize: '13px', color: '#EF4444', fontWeight: '500' }}>12 overdue</div>
            <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: '#FEE2E2', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#EF4444' }}>
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>
            </div>
          </div>
        </div>

        <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <div style={{ fontSize: '14px', color: '#6B7280', marginBottom: '8px', fontWeight: '500' }}>Monthly Revenue</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>$642,780</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div style={{ fontSize: '13px', color: '#10B981', fontWeight: '500' }}>+15.4% vs last month</div>
            <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: '#D1FAE5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10B981' }}>
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
            </div>
          </div>
        </div>

        <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <div style={{ fontSize: '14px', color: '#6B7280', marginBottom: '8px', fontWeight: '500' }}>Net Profit</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>$189,230</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div style={{ fontSize: '13px', color: '#10B981', fontWeight: '500' }}>+12.1% vs last month</div>
            <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: '#D1FAE5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10B981' }}>
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
            </div>
          </div>
        </div>
      </div>

      {/* Charts Row */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        <div style={{ padding: '24px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: '0 0 20px 0' }}>Cash Flow</h3>
          <div style={{ height: '240px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={cashFlowData} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6B7280' }} dy={10} />
                <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6B7280' }} tickFormatter={(val) => '$' + val + 'k'} />
                <Tooltip cursor={{fill: 'transparent'}} contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                <Legend iconType="circle" wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }} />
                <Bar dataKey="inflow" name="Inflow" fill="#8b5cf6" radius={[4, 4, 0, 0]} barSize={12} />
                <Bar dataKey="outflow" name="Outflow" fill="#c4b5fd" radius={[4, 4, 0, 0]} barSize={12} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div style={{ padding: '24px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>Revenue Trend</h3>
            <select style={{ padding: '4px 8px', borderRadius: '6px', border: '1px solid #E5E7EB', fontSize: '12px', color: '#374151', cursor: 'pointer' }}>
              <option>Monthly</option>
            </select>
          </div>
          <div style={{ height: '240px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={revenueData} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6B7280' }} dy={10} />
                <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6B7280' }} tickFormatter={(val) => '$' + val + 'k'} />
                <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                <Line type="monotone" dataKey="value" stroke="#8b5cf6" strokeWidth={3} dot={{ r: 4, fill: '#fff', stroke: '#8b5cf6', strokeWidth: 2 }} activeDot={{ r: 6 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Bottom Row */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '20px' }}>
        <div style={{ padding: '24px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: '0 0 20px 0' }}>Expense Breakdown</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <div style={{ width: '160px', height: '160px', position: 'relative' }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={expenseData}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={80}
                    paddingAngle={2}
                    dataKey="value"
                    stroke="none"
                  >
                    {expenseData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827' }}>$312,560</div>
                <div style={{ fontSize: '12px', color: '#6B7280' }}>Total</div>
              </div>
            </div>
            
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {expenseData.map((item, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '13px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: item.color }}></div>
                    <span style={{ color: '#4B5563' }}>{item.name}</span>
                  </div>
                  <div style={{ fontWeight: '500', color: '#111827' }}>
                    ${(item.value).toLocaleString()} <span style={{ color: '#9CA3AF', fontWeight: '400' }}>({((item.value / 312560) * 100).toFixed(1)}%)</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ padding: '24px', backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: '0 0 20px 0' }}>Recent Transactions</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #E5E7EB' }}>
                <th style={{ padding: '12px 0', color: '#6B7280', fontSize: '13px', fontWeight: '500' }}>Date</th>
                <th style={{ padding: '12px 0', color: '#6B7280', fontSize: '13px', fontWeight: '500' }}>Description</th>
                <th style={{ padding: '12px 0', color: '#6B7280', fontSize: '13px', fontWeight: '500' }}>Type</th>
                <th style={{ padding: '12px 0', color: '#6B7280', fontSize: '13px', fontWeight: '500', textAlign: 'right' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((txn, idx) => (
                <tr key={idx} style={{ borderBottom: idx !== transactions.length - 1 ? '1px solid #F3F4F6' : 'none' }}>
                  <td style={{ padding: '14px 0', fontSize: '14px', color: '#111827' }}>{txn.date}</td>
                  <td style={{ padding: '14px 0', fontSize: '14px', color: '#4B5563' }}>{txn.description}</td>
                  <td style={{ padding: '14px 0', fontSize: '14px', color: '#4B5563' }}>{txn.type}</td>
                  <td style={{ padding: '14px 0', fontSize: '14px', fontWeight: '500', color: txn.amount.startsWith('-') ? '#111827' : '#10B981', textAlign: 'right' }}>{txn.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: '16px' }}>
            <a href="#" style={{ color: '#6366f1', fontSize: '14px', textDecoration: 'none', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '4px' }}>
              View all transactions <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </a>
          </div>
        </div>
      </div>
      
    </div>
  );
}


